import React from 'react';
import {Link, NavLink} from "react-router-dom";
import "../style/solicitorLayoutHeader.css"
import BreadCrumb from "./breadcrumb";
import SolicitorHomeSlider from "./General/solicitorHomeSlider";
import aragLogo from '../assets/images/araglogo2.png';
const SolicitorLayoutHeader = (props) => {
	let icon = '';
	if(props.notificationsIconCount!==undefined && props.notificationsIconCount>0)
		icon = <span className="notifications-icon">{props.notificationsIconCount}</span>;
	return (
		<div className="row solicitor-layout-row print">
			<div className=" ">
				<div className="col-sm-12 solicitor-layout-header-wrapper">
					<div className="solicitor-layout-header-search-box">
						<svg className="solicitor-layout-header-search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><title>Asset 6</title>
							<g id="Layer_2" data-name="Layer 2">
								<g id="info">
									<path
										d="M15.61,13.72l-3.48-3.48-.06,0a6.58,6.58,0,1,0-1.88,1.88l0,.06,3.48,3.48a1.34,1.34,0,0,0,1.89-1.89Zm-9-2.84a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,6.58,10.88Z"/>
								</g>
							</g>
						</svg>
					</div>
					<div  className="solicitor-layout-header-link-last" >
						<a href="#" onClick={(e)=>{e.preventDefault();props.logout();}} style={{paddingLeft:'10px', borderLeft:'1px solid rgba(0, 0, 0, .25)' }} >Log off</a>
					</div>
					<NavLink className="solicitor-layout-header-link-last" to={"/manage-account"} activeClassName="solicitor-layout-header-link-active">{"Manage Account"}</NavLink>
                    {props.userRoles.includes('Broker') && (
                        <NavLink
                            className="solicitor-layout-header-link"
                            to={"/quotes"}
                            activeClassName="solicitor-layout-header-link-active">{'Quotes'}</NavLink>
                    )}
					{props.userRoles.includes('Broker') && (
                        <NavLink
                            className="solicitor-layout-header-link"
                            to={"/quote"}
                            activeClassName="solicitor-layout-header-link-active">{'New Quote'}</NavLink>
                    )}
					{props.userRoles.includes('Solicitor') && (
						<NavLink
							className="solicitor-layout-header-link"
							to={"/notifications"}
							activeClassName="solicitor-layout-header-link-active">Notifications {icon}</NavLink>
                    )}
                    {
						props.solicitorGroupAllowedToApplyForDisbursements?
                        <NavLink className="solicitor-layout-header-link" to={"/advance-disbursements"} activeClassName="solicitor-layout-header-link-active">Advance Disbursements</NavLink>
                        :
                        null
                    }
					{
						props.userRoles.includes('Solicitor') && (
							<NavLink
								className="solicitor-layout-header-link"
								to={"/application-and-policies"}
								activeClassName="solicitor-layout-header-link-active"
							>
								{"Applications & Policies"}
							</NavLink>
						)
					}
                    {
                        props.userRoles.includes('Solicitor') && (
                        	<NavLink
								className="solicitor-layout-header-link"
								to={"/new-application"}
								activeClassName="solicitor-layout-header-link-active"
							>
								{"New Application"}
							</NavLink>
                        )
                    }
					<img className="solicitor-layout-header-logo" src={aragLogo} alt="" onClick={()=>props.push('/')}/>
				</div>
			</div>
			<div className="row">
				<div className="col-sm-12 ">
					<SolicitorHomeSlider
						fetchingImages={props.fetchingImages}
						imageCounter={props.imageCounter}
						fetchedImageIndexes={props.fetchedImageIndexes}
						incrementImageCounter={props.incrementImageCounter}
						images={props.images}/>
				</div>
			</div>
			<div className={'row'}>
				<div className="col-xs-12 ">
					<div className={'solicitor-layout-header-telephone-section'}>
						{
							props.solicitorHomePageInfo.map((item, index) => {
								return (
									<div className="" key={item.id}>
										<div className={'layout-info__item'}>
											<span className="solicitor-layout-header-telephone-section-paragraph-number"><div dangerouslySetInnerHTML={{ __html: item.title }} /></span>
											<span className="solicitor-layout-header-telephone-section-paragraph-description">{item.body}</span>
											{(index + 1 < props.solicitorHomePageInfo.length) && (
												<div className="solicitor-layout-vertical-rule "></div>
											)}
										</div>
									</div>
								)
							})
						}
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-sm-12">
					<BreadCrumb
						PathName={props.locationPathName}
						Push={props.push}
						BreadcrumbStyle="user-layout-footer-breadcrumb "
						Wrapper="user-layout-footer-breadcrumb-wrapper" />
				</div>
			</div>
			<div className="row" style={{display: 'none'}}>
				<div className="col-sm-12 ">
					<div className="solicitor-layout-header-note1">
						Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut.
					</div>
				</div>
			</div>
			<div className="row" style={{display: 'none'}}>
				<div className="col-sm-12 ">
					<div className="solicitor-layout-header-note2">
						Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut.
					</div>

				</div>
			</div>
		</div>
	)
};

export default SolicitorLayoutHeader;
